import { render, staticRenderFns } from "./SelectGroupYear.vue?vue&type=template&id=28cfe3e0"
import script from "./SelectGroupYear.vue?vue&type=script&lang=js"
export * from "./SelectGroupYear.vue?vue&type=script&lang=js"
import style0 from "./SelectGroupYear.vue?vue&type=style&index=0&id=28cfe3e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports